module.exports = __webpack_public_path__ + "team-stairs-da1e21e95e8e8b22e7883551848dfbc7.webp";